<template>
    <AppLayout class="custom-formulation">
        <BaxHeaderBannerSimple :user="this.$store.state.auth.user" :containerClass="'full-page'">
        Custom Formulation
        </BaxHeaderBannerSimple>
        <main class="request-custom-formulation">
            <div class="bax-section">
                <div class="container full-page" v-if="asyncDataLoaded === true">
                    <div class="form-section" v-if="!formSubmittedSuccess">
                        <div class="form-container">
                            <div class="panel">
                                <div class="intro">
                                    <h3>Request a Custom PN Formulation</h3>
                                    <p>Tell us what you need and our Customer Service team will get back to you.</p>
                                </div>
                            </div>
                            <div class="panel">
                                <h4>Your Details</h4>
                                <div class="formulation-form-row">
                                    <div class="form-group col-4">
                                        <label for="first_name">First name</label>
                                        <input type="text" class="form-control" v-model="formData.first_name">
                                        <span class="form-error" v-if="$v.formData.first_name.$dirty && !$v.formData.first_name.required">Required field</span>
                                    </div>
                                    <div class="form-group col-4">
                                        <label for="last_name">Last name</label>
                                        <input type="text" class="form-control" v-model="formData.last_name">
                                        <span class="form-error" v-if="$v.formData.last_name.$dirty && !$v.formData.last_name.required">Required field</span>
                                    </div>
                                    <div class="form-group col-4">
                                        <label for="hospital">Hospital</label>
                                        <input type="text" class="form-control" disabled v-model="formData.hospital">
                                    </div>
                                </div>
                                <div class="formulation-form-row">
                                    <div class="form-group col-4" v-if="formData.country === 'Australia'">
                                        <label for="state">State</label>
                                        <select v-model="formData.state" class="form-control">
                                            <option class="d-none" value="">- Select -</option>
                                            <option v-for="(item, index) in statesList" :value="item" v-bind:key="index">
                                                {{ item }}
                                            </option>
                                        </select>
                                        <span class="form-error" v-if="$v.formData.state.$dirty && !$v.formData.state.required">Required field</span>
                                    </div>
                                    <div class="form-group col-4" v-if="formData.country === 'New Zealand'">
                                        <label for="state">Nearest city</label>
                                        <select v-model="formData.nearestCity" class="form-control">
                                            <option class="d-none" value="">- Select -</option>
                                            <option v-for="(item, index) in nearestCityList" :value="item" v-bind:key="index">
                                                {{ item }}
                                            </option>
                                        </select>
                                        <span class="form-error" v-if="$v.formData.nearestCity.$dirty && !$v.formData.nearestCity.required">Required field</span>
                                    </div>
                                    <div class="form-group col-4">
                                        <label for="email">Email</label>
                                        <input type="text" class="form-control" v-model="formData.email">
                                        <span class="form-error" v-if="$v.formData.email.$dirty && !$v.formData.email.required">Required field</span>
                                        <span class="form-error" v-if="$v.formData.email.$dirty && !$v.formData.email.email">Not a valid email</span>
                                    </div>
                                    <div class="form-group col-4">
                                        <label for="phone">Phone</label>
                                        <input type="text" class="form-control" v-model="formData.phone">
                                        <span class="form-error" v-if="$v.formData.phone.$dirty && !$v.formData.phone.required">Required field</span>
                                    </div>
                                </div>
                            </div>
                            <div class="panel">
                                <h4>Your Custom PN Formulation</h4>
                                <div class="formulation-form-row">
                                    <div class="form-group col-12 formulation-radio">
                                    <h5 class="label">Formulation base</h5>
                                        <div class="bax-boxed-radio">
                                            <div class="bax-radio" v-for="(item, index) in formulationsList" :key="index">
                                                <input type="radio" :id="'formulation_' + index" class="css-checkbox" :value="item" v-model="formData.formulation" />
                                                <label :for="'formulation_' + index" class="css-label">{{item}}</label>
                                            </div>
                                        </div>
                                        <span class="form-error" v-if="$v.formData.formulation.$dirty && !$v.formData.formulation.required">Required field</span>
                                    </div>
                                </div>
                            </div>
                            <div class="panel">
                                <h4>Additional Information</h4>
                                <div class="formulation-form-row">
                                    <div class="form-group col-12">
                                        <textarea class="form-control" v-model="formData.notes"></textarea>
                                        <span class="form-error" v-if="$v.formData.notes.$dirty && !$v.formData.notes.required">Required field</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="navigation-container">
                            <button type="button" class="bax-btn bax-btn-bordered-blue-brand" @click.prevent="onFormCancel">Cancel</button>
                            <button type="button" class="bax-btn bax-btn-blue-brand" :class="{ 'loading': formSubmitting }" @click.prevent="onFormSubmit">Submit</button>
                        </div>
                        <div class="feedback" v-if="formSubmitFeedback"><p>{{formSubmitFeedback}}</p></div>
                    </div>
                    <div class="form-section" v-if="formSubmittedSuccess">
                        <div class="panel">
                            <div class="intro">
                                <h3>Thank you for your query</h3>
                                <p>Your custom formulation has been sent to our Customer Service team and will be processed as soon as possible.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </AppLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import AppLayout from '@/components/layout/AppLayout.vue';
import BaxHeaderBannerSimple from '@/components/layout/BaxHeaderBannerSimple.vue';
import { scrollPageToTop, scrollPageToFirstError } from '@/core/helpers';
import CustomFormulationService from '@/core/api/tpn/customFormulation.service';
import { required, requiredIf, email } from 'vuelidate/lib/validators';

export default {
    name: 'CustomFormulationContact',
    components: {
        AppLayout,
        BaxHeaderBannerSimple,
    },
    data() {
        return {
            asyncDataLoaded: false,
            statesList: [],
            nearestCityList: [],
            formulationsList: [],
            validForm: true,
            formSubmitting: false,
            formSubmittedSuccess: false,
            formSubmitFeedback: false,
            formData: {
                first_name: '',
                last_name: '',
                hospital: '',
                country: this.$store.state.auth.user.hospitalCountry,
                state: '',
                nearestCity: '',
                email: '',
                phone: '',
                formulation: '',
                notes: '',
            },
        };
    },
    validations: {
        formData: {
            first_name: {
                required,
            },
            last_name: {
                required,
            },
            state: {
                required: requiredIf(function () {
                    if (this.formData.country === 'Australia') {
                        return true;
                    }
                    return false;
                }),
            },
            nearestCity: {
                required: requiredIf(function () {
                    if (this.formData.country === 'New Zealand') {
                        return true;
                    }
                    return false;
                }),
            },
            email: {
                required,
                email,
            },
            phone: {
                required,
            },
            formulation: {
                required,
            },
            notes: {
                required,
            },
        },
    },
    computed: {
        ...mapGetters(['authenticatedUser']),
    },
    created() {
        scrollPageToTop();

        CustomFormulationService.getCustomFormulationRequest()
        .then((res) => {
            const { data } = res;
            this.formData.first_name = data.userFirstName;
            this.formData.last_name = data.userLastName;
            this.formData.hospital = data.userHospitalName;
            this.formData.email = data.userEmail;
            this.statesList = data.states;
            this.nearestCityList = data.nzClosestCities;
            this.formulationsList = data.formulations;
            this.asyncDataLoaded = true;
        });
    },
    methods: {
        onFormCancel() {
            if (!this.formSubmitting) {
                this.$router.push({ name: 'homeTPN' });
            }
        },
        onFormSubmit() {
            this.$v.$touch();
            this.validForm = !this.$v.$invalid;
            this.$nextTick(() => scrollPageToFirstError('form-error'));

            if (this.validForm) {
                this.formSubmitting = true;

                const payload = {
                    formData: this.formData,
                };

                CustomFormulationService.createCustomFormulationRequest(payload)
                .then((res) => {
                    if (res.data.error) {
                        this.formSubmitFeedback = 'Sorry, something went wrong';
                    } else {
                        this.formSubmittedSuccess = true;
                    }
                  this.formSubmitting = false;
                })
                .catch((err) => {
                    if (err.response.status === 400) {
                        this.formSubmitFeedback = 'Sorry, something went wrong';
                        this.formSubmitting = false;
                    }
                });
            }
        },
    },
};
</script>
